import { landedCostSettingsSchema } from "@redotech/redo-model/landed-cost/landed-cost-settings";
import * as z from "zod/v4";

export const updateLandedCostSettings = {
  name: "updateLandedCostSettings" as const,
  input: z.object({ teamId: z.string(), landedCost: landedCostSettingsSchema }),
  output: z.null(),
};
